export const getCurrentLocationForRef = () =>
  encodeURIComponent(`${window.location.pathname}${window.location.search}`);
